import script from "./CardFontAttribute.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFontAttribute.vue?vue&type=script&setup=true&lang=js"

import "./CardFontAttribute.vue?vue&type=style&index=0&id=15b821ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b821ef"]])

export default __exports__